import React from 'react';
import { BookOpenIcon, CalendarClockIcon, CircleAlertIcon, FrownIcon } from 'lucide-react';
const pains = [{
  icon: CalendarClockIcon,
  title: '😰 Constant Program Planning',
  body: 'Every week you spend hours creating strength programs, organizing speed and agility sessions, designing conditioning workouts, planning periodization, adjusting training loads, and preparing sessions for athletes with different sports, ages, positions, goals, and performance levels.'
}, {
  icon: CircleAlertIcon,
  title: '⚠️ Unsure How to Structure the Next Training Session',
  intro: 'You constantly ask yourself...',
  questions: ["What should today's training focus be?", 'Should we prioritize strength, power, speed, or conditioning?', 'Are my athletes ready to increase the training load?', "How should I organize this week's sessions around practices, games, or competitions?", 'How can I safely progress athletes who are all at different levels?'],
  body: 'Planning every session becomes a constant challenge.'
}, {
  icon: BookOpenIcon,
  title: '📚 Coaching Resources Everywhere',
  resources: ['Strength exercises.', 'Speed drills.', 'Conditioning workouts.', 'Power development.', 'Periodization models.', 'Performance testing.', 'Coaching templates.'],
  body: "Everything exists... But it's scattered across books, certifications, coaching courses, spreadsheets, YouTube videos, websites, PDFs, and dozens of folders on your computer. Nothing is organized into one complete coaching system you can confidently use every day."
}, {
  icon: FrownIcon,
  title: '😩 Programming Burnout',
  body: "Between building weekly programs, organizing training blocks, preparing athlete assessments, tracking performance, adjusting workloads, planning the competitive season, and preparing every session, there's very little time left to focus on what truly matters: Helping your athletes perform at their highest level."
}];
export function PainSection() {
  return <section className="border-y border-line bg-canvas px-4 py-6 sm:py-8" data-id="element-154" data-mp="u23ofz15lxra">
      <div className="mx-auto max-w-4xl" data-id="element-155" data-mp="ytviijjiqlm6">
        <header className="mb-4 text-center" data-id="element-156" data-mp="yuwsslspn42u">
          <h2 className="text-2xl font-extrabold uppercase leading-tight text-navy sm:text-3xl" data-id="element-157" data-mp="12v79ase4pcvy">
            DOES THIS SOUND FAMILIAR?
          </h2>
          <p className="mx-auto mt-2 max-w-3xl text-sm leading-relaxed text-graphite sm:text-base" data-id="element-158" data-mp="669dd6un78x7">
            You love helping athletes become stronger, faster, more explosive,
            and more resilient—but planning every training session is consuming
            your entire week.
          </p>
          <p className="mx-auto mt-2 max-w-3xl text-sm leading-relaxed text-graphite" data-id="element-159" data-mp="k6ag6rugwqfb">
            If you&apos;re a Strength &amp; Conditioning Coach working with
            sports teams, private athletes, academies, universities,
            high-performance centers, clubs, or gyms, you&apos;ve probably
            experienced at least one of these situations:
          </p>
        </header>

        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-160" data-mp="20q172jghbcgm">
          {pains.map(({
          icon: Icon,
          title,
          intro,
          questions,
          resources,
          body
        }) => <article key={title} className="rounded-lg border border-line bg-white p-3 shadow-sm" data-id="element-161" data-mp="1rwo56s0ft0ie">
                <div className="flex gap-3" data-id="element-162" data-mp="1myweg1bj3kfs">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-sport/10 text-sport" data-id="element-163" data-mp="1hyi76lhr4eit">
                    <Icon className="h-4 w-4" aria-hidden="true" data-id="element-164" data-mp="1cydpis53xdr0" />
                  </div>
                  <div data-id="element-165" data-mp="18y243d4x79eh">
                    <h3 className="text-sm font-extrabold uppercase leading-tight text-navy" data-id="element-166" data-mp="18yvfiretqn2y">
                      {title}
                    </h3>
                    {intro && <p className="mt-1 text-sm font-semibold text-graphite" data-id="element-167" data-mp="33bbjtmo27r56">
                        {intro}
                      </p>}
                    {questions && <ul className="mt-1 list-disc space-y-0.5 pl-4 text-xs leading-snug text-graphite marker:text-electric" data-id="element-168" data-mp="3fe4dwgfeffk8">
                        {questions.map(item => <li key={item} data-id="element-169" data-mp="35feweorezx4i">{item}</li>)}
                      </ul>}
                    {resources && <ul className="mt-1 grid grid-cols-2 gap-x-2 text-xs font-semibold leading-snug text-graphite" data-id="element-170" data-mp="2rmywhwtt8f7t">
                        {resources.map(item => <li key={item} data-id="element-171" data-mp="2hrf59nq6y4pe">{item}</li>)}
                      </ul>}
                    <p className="mt-1.5 text-xs leading-relaxed text-graphite sm:text-sm" data-id="element-172" data-mp="2mpgnk6fslzzt">
                      {body}
                    </p>
                  </div>
                </div>
              </article>)}
        </div>
      </div>
    </section>;
}